/**
 * Shared filter utilities — extracted from FilterToolbar.jsx
 */

const toStr = (v) => (v == null ? '' : String(v).trim());

/**
 * Deduplicate and sort an array of strings.
 * Numeric-only values sort numerically; everything else uses locale comparison.
 */
export const uniqueSorted = (arr) => {
  const clean = (arr || []).map((x) => toStr(x)).filter((x) => x !== '');
  const out = Array.from(new Set(clean));

  const allNumeric = out.every((x) => /^-?\d+(\.\d+)?$/.test(String(x)));
  if (allNumeric) out.sort((a, b) => Number(a) - Number(b));
  else out.sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }));

  return out;
};

/**
 * Normalize a search string: lowercase, strip diacritics, collapse whitespace.
 */
export const normalizeSearchText = (s) =>
  String(s ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ');

/**
 * Filter an options list by a multi-token search query.
 * Every token must be present (AND semantics).
 */
export const filterStringOptions = (options, query) => {
  const q = normalizeSearchText(query);
  if (!q) return options;

  const tokens = q.split(' ').filter(Boolean);
  if (!tokens.length) return options;

  return (options || []).filter((opt) => {
    const val = normalizeSearchText(opt);
    return tokens.every((t) => val.includes(t));
  });
};
